export class CodigosRespuestaSIAFPConstants {
    public static RESPUESTA_EXITOSA = '00';
    public static ERROR_DE_ESTRUCTURA_O_FORMATO = '01';
    public static NO_SE_ENCUENTRA_AFILIADO = '20';
    public static ERROR_TECNICO = '03';
    public static NO_SE_ENCUENTRA_REGISTRO = '21';
}
